import React from 'react'

interface IconVipCrownProps {
  /** 图标尺寸(正方形),默认 14 */
  size?: number
  className?: string
  style?: React.CSSProperties
}

/**
 * 黄色渐变 VIP 皇冠图标,用于替代各处的 👑 emoji。
 *
 * - 公共组件:aiClerk / ai-photo-king 等多处复用,放在 pages/components 下避免反向依赖。
 * - 渐变 id 固定为 aiVipCrownGrad;同页面多个实例会重复该 id,浏览器统一引用首个定义,
 *   渐变定义一致,视觉无差异。
 * - 默认 verticalAlign 让图标跟在文字后面时基线对齐,贴近原来 emoji 的位置。
 */
const IconVipCrown: React.FC<IconVipCrownProps> = ({
  size = 14,
  className,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ verticalAlign: '-0.15em', ...style }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66569 3.65388C1.29081 3.42895 0.822084 3.73703 0.879863 4.17037L1.68548 10.2125C1.85936 11.5166 2.97179 12.4905 4.28745 12.4905H9.71132C11.027 12.4905 12.1394 11.5166 12.3133 10.2125L13.1189 4.17037C13.1767 3.73703 12.708 3.42895 12.3331 3.65388L10.1307 4.97528L7.40032 1.69877C7.19167 1.44839 6.80711 1.44839 6.59846 1.69877L3.86803 4.97528L1.66569 3.65388ZM6.01833 7.09765C5.76612 6.67731 5.12056 6.85612 5.12056 7.34631C5.12056 7.43391 5.14437 7.51986 5.18944 7.59498L6.38554 9.58848C6.66358 10.0519 7.33517 10.0519 7.61321 9.58848L8.80931 7.59498C8.85438 7.51986 8.87819 7.43391 8.87819 7.34631C8.87819 6.85612 8.23263 6.67731 7.98043 7.09765L7.06681 8.62033C7.03627 8.67124 6.96249 8.67124 6.93194 8.62033L6.01833 7.09765Z"
      fill="url(#aiVipCrownGrad)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.01886 7.09767C5.76666 6.67734 5.12109 6.85615 5.12109 7.34634C5.12109 7.43394 5.1449 7.51989 5.18997 7.59501L6.38607 9.5885C6.66411 10.0519 7.33571 10.0519 7.61375 9.5885L8.80984 7.59501C8.85491 7.51989 8.87872 7.43394 8.87872 7.34634C8.87872 6.85615 8.23316 6.67733 7.98096 7.09767L7.06734 8.62036C7.0368 8.67127 6.96302 8.67127 6.93247 8.62036L6.01886 7.09767Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="aiVipCrownGrad"
        x1="0.688239"
        y1="3.23635"
        x2="9.50173"
        y2="10.4697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDA7B" />
        <stop offset="1" stopColor="#CB9360" />
      </linearGradient>
    </defs>
  </svg>
)

export default IconVipCrown
